<div class="forgot-password">
  <div class="title txt-center">
    <h4>Password reset</h4>
    <h5>Your password has been successfully reset.</h5>
    <h5>Click below to login</h5>
  </div>
</div>